<template>
  <div>
    <p class="text-center">
      您所选择的画面名称为：{{ selectImgName }}，对应小欧画面匹配点位列表如下
    </p>
    <Divider style="margin: 10px 0;"/>

    <Row :gutter="6" class="m-b-10">
      <i-col :xs="24" :sm="12" :md="4" :lg="3" class="m-b-5">
        <DatePicker v-model="query.actionDate" type="date" :clearable="false" size="small" placeholder="作业时间(默认今天)" style="width: 100%"></DatePicker>
      </i-col>
      <i-col v-show="!showMap" :xs="24" :sm="12" :md="6" :lg="3" class="m-b-5">
        <i-select size="small" placeholder="选择资产" v-model="selectAssetId" @on-change="handleChangeAsset">
          <Option :value="-1">全部资产</Option>
          <i-option :value="item.id" v-for="item in assetArray" :key="'asset_' + item.id">{{ item.name }}</i-option>
        </i-select>
      </i-col>
      <i-col v-show="!showMap" :xs="24" :sm="12" :md="6" :lg="3" class="m-b-5">
        <i-select size="small" placeholder="站点（可通过关键字搜索）" filterable clearable v-model="query.stationId">
          <i-option :value="item.id" v-for="item in stationArray" :key="'station_' + item.id">{{ selectAssetId === -1 ?
            `${item.name}
            - ${item.assetName}` : item.name }}</i-option>
        </i-select>
      </i-col>
      <i-col v-show="!showMap" :xs="24" :sm="12" :md="6" :lg="4" class="m-b-5">
        <i-input size="small" placeholder="关键字：支持资源编号查询" v-model="query.keyword"></i-input>
      </i-col>
      <i-col span="11" class="m-b-5">
        <i-button size="small" class="m-r-5" type="primary" icon="ios-search" @click="handleSearch()">搜索</i-button>
        <Button size="small" type="success" class="m-r-5" @click="handleDownload()">下载资源列表</Button>
        <i-button size="small" type="success" class="m-r-5" icon="ios-globe-outline" @click="handleChangePageType()">
          {{ showMap? '切换列表显示':'切换地图显示' }}
        </i-button>
      </i-col>
    </Row>

    <template v-if="showMap">
      <SvgLine ref="svglineRef" embedPage @map-finished="handleMapLoadFinished" @on-click-station="handleClickStation"/>
    </template>
    <template v-else>
      <Table size="small" stripe :data="list" :columns="tableColumns" :loading="tableLoading"></Table>
      <div class="paging_style">
        <Page size="small" :total="total" :page-size="query.pageSize" show-total show-elevator :current="query.pageNumber"
          @on-change="handlePageChanged"></Page>
      </div>
    </template>

    <div>
      <SvgStation ref="svgStationRef" :stationSvgModal.sync="stationSvgModal" :stationId="chooseStationId" :svgShowType="4"
            :searchSchedules="[{startDate: query.actionDate, endDate: query.actionDate}]"
            @svg-finished="svgFinished" @on-select="handleSelectSvgResource"/>

      <DemandImage ref="demandImageRef"/>
    </div>

    <Spin fix size="large" v-if="spinShow">
        <Icon type="ios-loading" size=18 class="spin-icon-load"></Icon>
        <div>地图加载中...</div>
    </Spin>
  </div>
</template>

<script>
// components
import DemandImage from './DemandImage.vue'
import SvgLine from '@/components/svg/SvgLine'
import SvgStation from '@/components/svg/SvgStation'

import { ParseDate } from '@/utils/dateFormat'
import { downloadFileRequest } from '@/utils/download'
/** apis */
import { getPublisherAssetList } from '@/api/rim/asset'
import { getRimStationByAssetIds } from '@/api/rim/station'
import { getImageResourcePage, getStationTaskCount, getStaionTaskList } from '@/api/msp/search'

export default {
  components: {
    DemandImage, SvgLine, SvgStation
  },
  data () {
    return {
      projectArray: [],
      selectAssetId: -1, // 用于选择全部资产
      assetArray: [], // 实体资产清单
      stationArray: [], // 站点清单

      selectImgName: '',

      tableLoading: false,
      total: 0,
      query: {
        actionDate: null,
        imageUrl: null,
        pageNumber: 1,
        pageSize: 15,
        assetId: null,
        stationId: null,
        keyword: ''
      },
      list: [],
      tableColumns: [
        { title: '资源编号', key: 'code' },
        { title: '资产', key: 'assetName' },
        { title: '站点', key: 'stationName' },
        { title: '区域', key: 'positionName' },
        { title: '媒体类型', key: 'deviceModelName' },
        {
          title: '发布历史',
          render: (h, params) => {
            const showLabels = []

            params.row.publishHistoryList.forEach(element => {
              if (element.startDate && element.endDate) {
                showLabels.push(h('p', element.startDate + ' 至 ' + element.endDate))
              } else if (element.startDate) {
                showLabels.push(h('p', element.startDate + ' 至今'))
              } else {
                showLabels.push(h('p', '/'))
              }
            })

            return h('div', showLabels)
          }
        },
        {
          title: '操作',
          render: (h, params) => {
            const showLabels = [
              h('a', {
                on: {
                  click: () => {
                    this.handleShowDetail(params.row)
                  }
                }
              }, '查看详情')
            ]

            return h('div', showLabels)
          }
        }
      ],

      showMap: false,
      spinShow: false,
      mapFinished: false,
      stationSvgModal: false,
      chooseStationId: 0,
      stationTaskList: []
    }
  },
  created () {
    this.initAssetArray()
  },
  methods: {
    initPageData (selectImg) {
      // this.showMap = false
      this.query.actionDate = new Date()
      this.query.imageUrl = selectImg.filePath
      this.selectImgName = selectImg.brandName !== 'null' ? selectImg.brandName : selectImg.fileName

      this.handleSearch()
    },
    initAssetArray () {
      getPublisherAssetList().then((res) => {
        this.assetArray = res
        this.handleChangeAsset()
      })
    },
    // 资产变更
    handleChangeAsset () {
      this.query.assetId = this.selectAssetId === -1 ? undefined : this.selectAssetId
      this.query.stationId = null
      const assetIds = this.selectAssetId === -1 ? this.assetArray.map(x => x.id) : [this.selectAssetId]
      getRimStationByAssetIds({ assetIds: JSON.stringify(assetIds) }).then((res) => {
        this.stationArray = res
      })
    },
    // 分页
    handlePageChanged (page) {
      this.query.pageNumber = page
      this.getTableData()
    },
    // 搜索
    handleSearch () {
      if (this.showMap) {
        this.LoadMapData()
      } else {
        this.query.pageNumber = 1
        this.getTableData()
      }
    },
    // 获取分页列表
    getTableData () {
      this.query.actionDate = ParseDate(this.query.actionDate)
      this.tableLoading = true
      getImageResourcePage(this.query).then((res) => {
        if (res && !res.errcode) {
          this.list = res.list
          this.total = res.totalRow
        } else {
          this.list = []
          this.total = 0
        }
      }).finally(() => { this.tableLoading = false })
    },
    handleDownload () {
      const filename = '素材在刊点位列表.xlsx'

      downloadFileRequest(process.env.VUE_APP_API_URL_V2 + '/ooh-msp/v1/search/downloadplanexcel', this.query, filename)
    },
    handleShowDetail (params) {
      this.$refs.demandImageRef.showModal(params)
    },
    handleChangePageType () {
      this.showMap = !this.showMap
      if (this.showMap) {
        this.spinShow = true
      } else {
        this.getTableData()
      }
    },
    handleMapLoadFinished (val) {
      this.mapFinished = val

      if (val) {
        this.spinShow = false
        // 需要隐藏其他线路
        this.$refs.svglineRef.hideOtherAsset(this.assetArray.map(x => x.id))
        // 获取站点数据
        this.LoadMapData()
      }
    },
    LoadMapData () {
      if (this.mapFinished) { // 验证地图是否加载完毕， 否则延迟1秒再次请求
        const query = {
          actionDate: ParseDate(this.query.actionDate),
          imageUrl: this.query.imageUrl
        }
        getStationTaskCount(query).then(res => {
          this.$refs.svglineRef.loadResourceStations(res.map(item => {
            return {
              id: item.stationId,
              quantity: item.count
            }
          }))
        })
      } else {
        setTimeout(() => {
          this.LoadMapData()
        }, 1000)
      }
    },
    handleClickStation (stationId) {
      this.chooseStationId = stationId
      this.stationSvgModal = true
    },
    svgFinished () { // SVG站点地图加载完毕
      const showBean = {
        actionDate: ParseDate(this.query.actionDate),
        imageUrl: this.query.imageUrl,
        stationId: this.chooseStationId
      }

      getStaionTaskList(showBean).then(res => {
        this.stationTaskList = res

        this.$refs.svgStationRef.tagResourceAndName(res.map(x => {
          return {
            deviceId: x.deviceId,
            brandName: x.brandName === '' ? x.advertiserName : x.brandName,
            stationId: x.stationId,
            floor: x.floor
          }
        }))
        this.$refs.svgStationRef.choseSpinShow()
      })
    },
    handleSelectSvgResource (deviceId) {
      const item = this.stationTaskList.find(x => x.deviceId === deviceId)
      console.log(item)
      this.$refs.demandImageRef.showModal(item)
    }
  }
}
</script>
